<template>
  <!-- Header -->
  <header class="header fixed-top">
  <nav class="navbar navbar-default">
    <div class="container-fluid">
      <div class="navbar-header">
        <a class="navbar-brand" href="index.html">
          <Logo  class="logo"/>
        </a>
      </div>
     </div>
  </nav>

  </header>
  <!-- Header close -->
</template>

<script>
import Logo from '../assets/images/logo.svg'

export default {
  name: 'Header',
  components: {
    Logo
  },
}
</script>
